import React from 'react';
import { Filter, X } from 'lucide-react';
import toast from 'react-hot-toast';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const CompanySizeFilters = ({ filters, search, onApply }) => {
  return (
    <div className="card">
      <div className="card-content">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="form-group">
            <label className="form-label">Nome</label>
            <input
              type="text"
              className="form-input"
              placeholder="Nome do tamanho"
              value={filters.filters.name}
              onChange={(e) => filters.updateFilter('name', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={filters.filters.isActive}
              onChange={(e) => filters.updateFilter('isActive', e.target.value)}
            >
              <option value="">Todos os status</option>
              <option value="true">Ativo</option>
              <option value="false">Inativo</option>
            </select>
          </div>
          
          <div className="form-group">
            <label className="form-label">Buscar</label>
            <input
              type="text"
              className="form-input"
              placeholder="Buscar tamanhos..."
              value={search.query}
              onChange={(e) => search.search(e.target.value)}
            />
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Can permission={P.CATALOG_ACCESS}>
              <button
                type="button"
                onClick={filters.clearFilters}
                className="btn btn-outline btn-sm"
              >
                <X className="w-4 h-4 mr-1" />
                Limpar
              </button>
            </Can>
            <Can permission={P.CATALOG_ACCESS}>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  if (onApply) onApply();
                  else toast.success('Filtros aplicados à lista.');
                }}
              >
                <Filter className="w-4 h-4 mr-1" />
                Filtrar
              </button>
            </Can>
          </div>
          
          <div className="text-sm text-gray-600">
            {filters.hasActiveFilters && 'Filtros ativos'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySizeFilters;
